// GraphQL Error type based on the GraphQL spec
export interface GraphQLError {
  message: string;
  extensions?: {
    code?: string;
    [key: string]: any;
  };
  locations?: Array<{
    line: number;
    column: number;
  }>;
  path?: Array<string | number>;
}

// Shopify-specific response wrapper
export interface ShopifyResponse<T> {
  data?: T;
  errors?: GraphQLError[] | { networkStatusCode?: number; message?: string; };
}

// Helper function to check if errors are GraphQL errors array
export function isGraphQLErrorArray(errors: unknown): errors is GraphQLError[] {
  return Array.isArray(errors) && errors.every(
    error => typeof error === 'object' && error !== null && 'message' in error
  );
}

// Helper function to extract error messages
export function extractErrorMessage(errors: GraphQLError[] | { networkStatusCode?: number; message?: string; } | unknown): string {
  if (isGraphQLErrorArray(errors)) {
    return errors.map(e => e.message).join(', ');
  } else if (errors && typeof errors === 'object' && 'message' in errors) {
    return String(errors.message) || 'Network error occurred';
  }
  return 'An unknown error occurred';
}